import { render, staticRenderFns } from "./aldata.vue?vue&type=template&id=3733d0a0&scoped=true&"
import script from "./aldata.vue?vue&type=script&lang=js&"
export * from "./aldata.vue?vue&type=script&lang=js&"
import style0 from "./aldata.vue?vue&type=style&index=0&id=3733d0a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733d0a0",
  null
  
)

export default component.exports